
import Vue from 'vue'   //引入Vue
import VueRouter from 'vue-router'  //引入vue-router
// import { setLanguageRequestParams } from '@/i18n';

Vue.use(VueRouter)  //Vue全局使用Router

const routes = [
  {
    path: '/',
    redirect: '/SafetyHome'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/login.vue'),
  },
  {
    path: '/verificationLogin',
    name: 'verificationLogin',
    component: () => import('@/views/Login/Verification-Login.vue'),
  },
  {
    path: '/loginChoose',
    name: 'loginChoose',
    component: () => import('@/views/Login/login-choose.vue'),
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/user-manage/index.vue'),
  },
  {
    path: '/pdfView',
    name: 'pdfView',
    component: () => import('@/views/all-PDF/index.vue'),
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/User/components/Reset-Password.vue'),
  },
  {
    path: '/SafetyHome',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: { name: 'SafetyHome' },
    children: [
      {
        path: '',
        name: 'SafetyHome',
        component: () => import('@/views/Safety-Home/Safety-Home.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'fire',
        name: 'Fire',
        component: () => import('@/views/Safety-Fire/Safety-Fire.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'work',
        name: 'Work',
        component: () => import('@/views/Safety-Work/Safety-Work.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: '/workDetail',
        name: 'workDetail',
        component: () => import('@/views/Safety-Work/components/Safety-Work-Detail.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: '/fireDetail',
        name: 'FireDetail',
        component: () => import('@/views/Safety-Fire/components/Safety-Fire-Detail.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'commuting',
        name: 'Commuting',
        component: () => import('@/views/Safety-Commuting/Safety-Commuting.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: '/commutingDetail',
        name: 'CommutingDetail',
        component: () => import('@/views/Safety-Commuting/components/Safety-Commuting-Detail.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'addList',
        name: 'addList',
        component: () => import('@/views/Add-List/Add-List.vue'),
      },
      {
        path: 'addStaticResource',
        name: 'addStaticResource',
        component: () => import('@/views/Add-Static-Resource/Add-Static-Resource.vue'),
      },
      {
        path: 'addOptions',
        name: 'addOptions',
        component: () => import('@/views/Add-Options/Add-Options.vue'),
      },
      {
        path: 'accidentSearch',
        name: 'accidentSearch',
        component: () => import('@/views/Safety-Home/components/Accident-Search.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'SafetyManagement',
        name: 'SafetyManagement',
        component: () => import('@/views/Safety-Announcement/Safety-Management.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      }, 
      {
        path: 'AccountAttachment',
        name: 'AccountAttachment',
        component: () => import('@/views/Account-Attachment/Account-Attachment.vue'),
        meta: { title:'TOPPAN-group-db-1' }
      },
      {
        path: 'EnAccountAttachment',
        name: 'EnAccountAttachment',
        component: () => import('@/views/Account-Attachment/Account-Attachment-En.vue'),
         meta: { title:'TOPPAN-group-db-2' }
      },
      {
        path: 'CompanyList',
        name: 'CompanyList',
        component: () => import('@/views/Company-List/Company-List.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db' }
      },
      {
        path: 'CompanyInformList',
        name: 'CompanyInformList',
        component: () => import('@/views/Company-List/components/company-inform/company-inform-list.vue'),
         meta: { title:'TOPPAN-group-db' }
      },
      {
        path: 'CompanyInformEdit',
        name: 'CompanyInformEdit',
        component: () => import('@/views/Company-List/components/company-inform/company-inform-edit.vue'),
        meta: { title:'TOPPAN-group-db' }
      },
      {
        path: 'CompanyInformDetail',
        name: 'CompanyInformDetail',
        component: () => import('@/views/Company-List/components/company-inform/company-inform-datail.vue'),
        
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db' }
      },
      {
        path: 'CompanyTree',
        name: 'CompanyTree',
        component: () => import('@/views/Company-List/Company-Tree.vue'),
        // meta: { tab: 'CompanyTree',title:'法人-Unlimited Edition' }
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db' }

      },
      {
        path: 'JaAccountDetail',
        name: 'JaAccountDetail',
        component: () => import('@/views/Company-List/components/Ja-legal/Ja-Account-Detail.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-1' }
      },
      {
        path: 'JpAccountEdit',
        name: 'JpAccountEdit',
        component: () => import('@/views/Company-List/components/Ja-legal/Ja-Account-Edit.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-1' }
      },
      {
        path: 'AiChat',
        name: 'AiChat',
        component: () => import('@/views/Company-List/components/Ja-legal/components/ai-chat.vue'),
        meta: {title:'TOPPAN-group-db' }
      },
      {
        path: 'addFirstLegal',
        name: 'addFirstLegal',
        component: () => import('@/views/Company-List/components/Ja-legal/components/add-first-legal.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db' }
      },
      {
        path: 'JpAccountBranchEdit',
        name: 'JpAccountBranchEdit',
        component: () => import('@/views/Company-List/components/Ja-legal/components/jp-account-branch-edit.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-1' }
      },
      {
        path: 'JpAccountBranchDetail',
        name: 'JpAccountBranchDetail',
        component: () => import('@/views/Company-List/components/Ja-legal/components/jp-account-branch-detail.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-1' }
      },
      {
        path: 'AccountEdit',
        name: 'AccountEdit',
        component: () => import('@/views/Company-List/components/En-legal/En-Account-Edit.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-2' }
      },
       {
        path: 'AccountDetail',
        name: 'AccountDetail',
        component: () => import('@/views/Company-List/components/En-legal/En-Account-Detail.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-2' }
      },
      {
        path: 'AccountBranchEdit',
        name: 'AccountBranchEdit',
        component: () => import('@/views/Company-List/components/En-legal/components/en-account-branch-edit.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-2' }
      },
      {
        path: 'AccountBranchDetail',
        name: 'AccountBranchDetail',
        component: () => import('@/views/Company-List/components/En-legal/components/en-account-branch-detail.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-2' }
      },
      {
        path: 'noticeAdd',
        name: 'noticeAdd',
        component: () => import('@/views/Safety-Announcement/components/Safety-Notice-Add.vue'),
        meta: { title:'TOPPAN-safety-portal' }

      },
      {
        path: 'SafetyEducation',
        name: 'SafetyEducation',
        component: () => import('@/views/Safety-Education/Safety-Education.vue'),
        meta: { requiresAuth: true,title:'TOPPAN-safety-portal' }
      },
      {
        path: 'educationAdd',
        name: 'educationAdd',
        component: () => import('@/views/Safety-Education/components/Safety-Education-Add.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'educationEdit',
        name: 'educationEdit',
        component: () => import('@/views/Safety-Education/components/Safety-Education-Edit.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'noticeDetail',
        name: 'noticeDetail',
        component: () => import('@/views/Safety-Announcement/components/Safety-Notice-Detail.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'noticeEdit',
        name: 'noticeEdit',
        component: () => import('@/views/Safety-Announcement/components/Safety-Notice-Edit.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'safetyAnnualReport',
        name: 'safetyAnnualReport',
        component: () => import('@/views/Safety-Home/components/Safety-Annual-Report.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'safetyYearReportEdit',
        name: 'safetyYearReportEdit',
        component: () => import('@/views/Safety-Home/components/Safety-Year-Report-Edit.vue'),
        meta: { title:'TOPPAN-safety-portal' }

      },
      {
        path: 'safetyAccount',
        name: 'SafetyAccount',
        component: () => import('@/views/Safety-Account/Safety-Account.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'safetyAccountDetail',
        name: 'SafetyAccountDetail',
        component: () => import('@/views/Safety-Account/components/Safety-Account-Detail.vue'),
        meta: { title:'TOPPAN-safety-portal' }
      },
      {
        path: 'SpecificSearch',
        name: 'SpecificSearch',
        component: () => import('@/views/Company-List/components/company-related/specific-search.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db' }
      },
      {
        path: 'AttachmentJaDetail',
        name: 'AttachmentJaDetail',
        component: () => import('@/views/Company-List/components/company-regulations/attachment-ja-detail.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-1' }
      },
      {
        path: 'AttachmentJaEdit',
        name: 'AttachmentJaEdit',
        component: () => import('@/views/Company-List/components/company-regulations/attachment-ja-edit.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-1' }
      },
      {
        path: 'AttachmentEnDetail',
        name: 'AttachmentEnDetail',
        component: () => import('@/views/Company-List/components/company-regulations/attachment-en-detail.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-2' }
      },
      {
        path: 'AttachmentEnEdit',
        name: 'AttachmentEnEdit',
        component: () => import('@/views/Company-List/components/company-regulations/attachment-en-edit.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-2'  }
      },
      {
        path: 'isoJpDetail',
        name: 'isoJpDetail',
        component: () => import('@/views/Company-List/components/iso/iso_jp_detail.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-1' }

      },
      {
        path: 'isoJpEdit',
        name: 'isoJpEdit',
        component: () => import('@/views/Company-List/components/iso/iso_jp_edit.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-1' }

      },
      {
        path: 'isoEnDetail',
        name: 'isoEnDetail',
        component: () => import('@/views/Company-List/components/iso/iso_en_detail.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-2' }

      },
      {
        path: 'isoEnEdit',
        name: 'isoEnEdit',
        component: () => import('@/views/Company-List/components/iso/iso_en_edit.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-2' }

      },
      {
        path: 'isoOthersDetail',
        name: 'isoOthersDetail',
        component: () => import('@/views/Company-List/components/iso/iso_others.vue'),
        meta: { tab: 'CompanyTree',title:'TOPPAN-group-db-2' }

      },
      {
        path: 'isoSupplyChainDetail',
        name: 'isoSupplyChainDetail',
        component: () => import('@/views/Company-List/components/iso/iso_supply_Chain.vue'),
        meta: {title:'TOPPAN-group-db-2' }

      },
      {
        path: 'addJaNote',
        name: 'addJaNote',
        component: () => import('@/views/Company-List/components/Ja-legal/components/add-ja-note.vue'),
        meta: { title:'TOPPAN-group-db-1' }
      },
      {
        path: 'addJaNoteFile',
        name: 'addJaNoteFile',
        component: () => import('@/views/Company-List/components/Ja-legal/components/add-ja-note-file.vue'),
        meta: { title:'TOPPAN-group-db-1' }
      },
      {
        path: 'JaNoteList',
        name: 'JaNoteList',
        component: () => import('@/views/Company-List/components/Ja-legal/components/ja-note-list.vue'),
        meta: { title:'TOPPAN-group-db-1' }
      },
      {
        path: 'addEnNote',
        name: 'addEnNote',
        component: () => import('@/views/Company-List/components/En-legal/components/add-en-note.vue'),
        meta: { title:'TOPPAN-group-db-2' }
      },
      {
        path: 'addEnNoteFile',
        name: 'addEnNoteFile',
        component: () => import('@/views/Company-List/components/En-legal/components/add-en-note-file.vue'),
        meta: { title:'TOPPAN-group-db-2' }

      },
      {
        path: 'EnNoteList',
        name: 'EnNoteList',
        component: () => import('@/views/Company-List/components/En-legal/components/en-note-list.vue'),
        meta: { title:'TOPPAN-group-db-2' }

      },
      {
        path: 'JaNoteDetail',
        name: 'JaNoteDetail',
        component: () => import('@/views/Company-List/components/Ja-legal/components/ja-note-detail.vue'),
        meta: { title:'TOPPAN-group-db-1' }
      },
      {
        path: 'EnNoteDetail',
        name: 'EnNoteDetail',
        component: () => import('@/views/Company-List/components/En-legal/components/en-note-detail.vue'),
        meta: { title:'TOPPAN-group-db-2' }
      },
      {
        path: 'UpdatePeriodically',
        name: 'UpdatePeriodically',
        component: () => import('@/views/Update-Periodically/Update-Periodically.vue'),
        // meta: { title:'定期更新-Unlimited Edition' }
        meta: { title:'TOPPAN-group-db' }


      },
      {
        path: 'emailSending',
        name: 'emailSending',
        component: () => import('@/views/Update-Periodically/components/email-sending.vue'),
        // meta: { title:'定期更新-Unlimited Edition' }
        meta: { title:'TOPPAN-group-db' , tab: 'UpdatePeriodically', }
      },
      {
        path: 'sendingEmailUpdate',
        name: 'sendingEmailUpdate',
        component: () => import('@/views/Company-List/components/sending-email-update/sending-email-update.vue'),
        // meta: { title:'送信更新邮件-Unlimited Edition' }
        meta: { title:'TOPPAN-group-db' }

      },
      {
        path: 'addSendEmail',
        name: 'addSendEmail',
        component: () => import('@/views/Company-List/components/sending-email-update/components/add-send-email.vue'),
        // meta: { tab: 'sendingEmailUpdate',title:'送信更新邮件の編集-Unlimited Edition' }
        meta: { tab: 'sendingEmailUpdate',title:'TOPPAN-group-db' }

      },
      {
        path: 'groupContent',
        name: 'groupContent',
        component: () => import('@/views/Company-List/components/En-legal/components/group_content.vue'),
        meta: {title:'TOPPAN-group-db-2' }

      },
      {
        path: 'policiesRegulationsUpload',
        name: 'policiesRegulationsUpload',
        component: () => import('@/views/Company-List/components/policies-regulations-upload/policies-regulations-upload.vue'),
      },
    ]
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// const originalPush = router.push;
import store from '@/store'
// 防止导航重复错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated

  // 定义公共页面（不需要认证的页面）
  const publicPages = ['/login', '/verificationLogin', '/resetPassword']
  
  // 已登录用户访问登录页 -> 跳转到首页
  if (isAuthenticated && (to.path === '/login' || to.path === '/verificationLogin')) {
    //TODO
    // return next('/SafetyHome')
  }
  document.title = to.meta.title || 'Unlimited Edition'
  // 重置密码页面不需要认证
  if (to.path === '/resetPassword') {
    return next()
  }
  

  // 检查是否需要认证（除了公共页面和重置密码页面，其他都需要认证）
  const requiresAuth = !publicPages.includes(to.path)
  if (requiresAuth && !isAuthenticated) {
    // 保存当前路径以便登录后返回
    //TODO:暂时隐藏，因为登陆后需要重新选择app
    // localStorage.setItem('redirect_path', to.fullPath)
    return next('/login')
  }

  next()
})
export default router;